import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Momentum.scss';
const Momentum = ({ size = 40, color = 'black', speed = 1.1, }) => {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
        }, children: _jsx("div", { className: styles.inner }) }));
};
export default Momentum;
